import { ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_COLORES, ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS } from './constantes';


export const cellRendererNumeroRegistro = (param) => {
  if (param.node.rowPinned) {
    return undefined;
  }

  return param.node.rowIndex + 1;
};

export const formatearErrores = (errores) => {
  if (typeof errores === 'string') {
    return errores;
  }

  let erroresFormateados = '';

  Object.keys(errores || {}).forEach((key) => {
    const itemsErrores = (errores[key] || []).map((item) => `<li>${item}</li>`).join('');

    erroresFormateados += itemsErrores;
  });

  return erroresFormateados;
};

export const formatearFechaHoraBolivia = (fecha) => {
  if (!fecha) {
    return '-';
  }

  const parametos = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };

  return new Date(fecha).toLocaleString('es-BO', parametos);
};

export const getPrograma = (programa) => {
  if (!programa?.id) {
    return '';
  }

  const color = 'primary';

  return /*html*/ `
    <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
        <span class="v-chip__content"> ${programa.codigo} </span>
    </span>
    ${programa.nombreCompuesto}
  `;
};

export const getProgramaModulo = (programaModulo) => {
  if (!programaModulo?.id) {
    return '';
  }

  const color = 'primary';

  return /*html*/ `
    <span class=" ${color}--text body-2">
        M(${programaModulo.numero}) - 
    </span>
    ${programaModulo.moduloNombre}
  `;
};
export const getSolicitante = (solicitante) => {
  if (!solicitante?.nroCi) {
    return 'No tiene información';
  }

  const color = 'primary';

  return /*html*/ `
    ${solicitante.nombreCompleto}
    <span class="${color}--text body-2 font-weight-medium"> ${solicitante.nroCi} </span>
  `;
};

export const getRevisor = (revisor) => {
  if (!revisor?.nroCi) {
    return 'No Se reviso';
  }

  const color = 'primary';

  return /*html*/ `
    ${revisor.nombreCompleto}
    <span class="${color}--text body-2 font-weight-medium"> ${revisor.nroCi} </span>
  `;
};

export const cellRendererEstadoSolicitud = (params) => {
  const estado = params?.data?.estadoSolicitud;
  const color = ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_COLORES[estado] || 'grey';
  const label = ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[estado] || estado || '-';

  return /*html*/ `
    <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
        <span class="v-chip__content"> ${label} </span>
    </span>
  `;
};

export const obtenerUrlAPICalificaciones = (uri) => {
  return `${process.env.VUE_APP_URL_API_CALIFICACIONES || ''}/api/${uri}`;
};
